import { axiosSwagger } from "@/axios";

export const state = {
    poolUser: {
        loading: false,
        data: [],
        total: 0,
        
        isMultiple: false,
        multipleSelectedID: [],
    },
    pagination: {
        list: {
          start: 0,
          limit: 6,
        }
    }
}


export const getters = {
}


export const mutations = {
    // POOL USER
    loading: (state, loading) => {
        state.poolUser.loading = loading;
    },
    setData: (state, data) => {
        state.poolUser.data = data;
    },
    setTotal: (state, total) => {
        state.poolUser.total = total;
    },
    add: (state, data) => {
        state.poolUser.data.push(data);
    },
    remove: (state, id) => {
        state.poolUser.data = state.poolUser.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.poolUser.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.poolUser.data[index].isOwner = data.isOwner;
            state.poolUser.data[index].canAddFiles = data.canAddFiles;
            state.poolUser.data[index].canAddMember = data.canAddMember;
        }
    },
    // multiple
    setIsMultiple: (state, boolean) => {
        state.poolUser.isMultiple = boolean;
    },
    setSingleMultipleID: (state, id) => {
        state.poolUser.multipleSelectedID = [id];
    },
    selectMultipleID: (state, id) => {
        // toggle multiple select
        if(!state.poolUser.multipleSelectedID?.includes(id)){
            state.poolUser.multipleSelectedID.push(id);
        }
        else{
            state.poolUser.multipleSelectedID = state.poolUser.multipleSelectedID.filter(
                (el) => el !== id
            );
        }
    },
    // eslint-disable-next-line no-unused-vars
    removeAllMultipleSelectID: (state, data) => {
        state.poolUser.multipleSelectedID = [];
    },
    setAllMultipleSelectID: (state, data) => {
        if(data?.length ?? false){
            data.forEach(e => {
                if(!state.poolUser.multipleSelectedID?.includes(e.id)){
                    state.poolUser.multipleSelectedID.push(e.id);
                }
            });
        }
    },
    removeSelectedMultipleSelectID: (state, data) => {
        if(data?.length ?? false){
            let _arrIds = data.map(e => e.id);
            
            state.poolUser.multipleSelectedID = state.poolUser.multipleSelectedID.filter(
                (el) => !_arrIds.includes(el)
            );
        }
    },
    // pagination LIST
    setPaginationListStart: (state, data) => {
        state.pagination.list.start = data;
    },
    setPaginationListLimit: (state, data) => {
        state.pagination.list.limit = data;
    },
    removeMultiple: (state, dataArr) => {
        state.poolUser.data = state.poolUser.data.filter(
          (el) => !dataArr?.includes(el.id)
        );
    },
    addMultiple: (state, dataArr) => {
        state.poolUser.data = state.poolUser.data.concat(...dataArr);
    }
}


export const actions = {
    // POOL USER
    async readPoolUserByPostPoolId({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/PoolUser/Pool/${id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async createPoolUser({ commit }, data) {
        return await axiosSwagger
        .post("/api/PoolUser", data)
        .then((response) => {
            let modifyData =  response.data;
            modifyData.user = data.user;

            commit("add", modifyData);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async createMultiplePoolUser({ commit }, data) {
        return await axiosSwagger
        .post("/api/PoolUser", data)
        .then((response) => {
            let modifyData =  response.data;
            modifyData.user = data.user;

            return modifyData;
        });
    },
    async deletePoolUser({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/PoolUser/${id}`)
        .then((response) => {
            commit("remove", id);

            return response;
        });
    },
    // eslint-disable-next-line no-unused-vars
    async deleteMultiplePoolUser({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/PoolUser/${id}`)
        .then((response) => {
            return response;
        });
    },
    async updatePoolUser({ commit }, data) {
        return await axiosSwagger
        .put(`/api/PoolUser/${data.id}`, data)
        .then((response) => {
            commit("update", data);

            return response;
        });
    },
}